if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');

        this.selectors = {
          variantIdSelect: '[name="id"]',
        };
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }
      get quantity() {
        return this.querySelector('quantity-input');
      }
      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
      get productId() {
        return this.getAttribute('data-product-id');
      }
      get select() {
        return this.querySelector('select');
      }
      get productForm() {
        return this.querySelector('form[is="product-form"]');
      }

      connectedCallback() {
        this.productFormActions = document.querySelector('.main-product-form');
        this.mainProductInfo = document.querySelector('product-info');
        this.container = this.closest('.sticky-atc-bar');

        this.variantData = this.getVariantData();
        this.currentVariant = this.variantData.find((variant) => variant.id === Number(this.select.value));

        this.init();
        this.setupPurchaseSync();
        this.select.addEventListener('change', () => {
          if (this.isUpdating) return;
          this.isUpdating = true;

          this.updateQuantityInput();

          this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');
          const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          if (this.mainVariantSelects) {
            Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
              const variantOptionVal = this.currentVariant.options[index];
              switch (element.tagName) {
                case 'SELECT':
                  element.value = variantOptionVal;
                  const options = element.querySelectorAll('option');
                  options.forEach((option) => option.removeAttribute('selected'));

                  element.value = variantOptionVal;
                  const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
                  if (selectedOption) {
                    selectedOption.setAttribute('selected', 'selected');
                  }
                  break;
                case 'FIELDSET':
                  Array.from(element.querySelectorAll('input')).forEach((radio) => {
                    if (radio.value === variantOptionVal) {
                      radio.checked = true;
                    }
                  });
                  break;
              }
            });
            setTimeout(() => {
              this.mainVariantSelects.dispatchEvent(new Event('change', { detail: { formStickty: true } }));
              this.isUpdating = false;
            }, 0);
          } else {
            this.isUpdating = false;
          }

          if (!this.currentVariant) return;
          this.updatePrice();
          this.updatePriceWithOptions();
          this.updateButton(true, '', false);
          if (!this.currentVariant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!this.currentVariant.available, FoxTheme.variantStrings.soldOut);
          }
          this.updatePurchaseButton();
        });
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.purchaseObserver?.disconnect();
        if (this.priceUpdateFrame) cancelAnimationFrame(this.priceUpdateFrame);
      }

      get mainSubmitButton() {
        return this.productFormActions?.querySelector('button[name="add"], button[type="submit"]');
      }

      setupPurchaseSync() {
        const stickyButton = this.querySelector('[data-sticky-add]');
        if (!stickyButton) return;

        stickyButton.addEventListener('click', () => this.handleStickyAdd());
        this.productForm.addEventListener('submit', (event) => {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.handleStickyAdd();
        }, true);
        this.addEventListener('change', (event) => {
          if (event.target.matches('quantity-input input')) this.syncQuantityToMainForm(false);
        });

        if (this.productFormActions) {
          this.purchaseObserver = new MutationObserver(() => {
            if (this.priceUpdateFrame) return;
            this.priceUpdateFrame = requestAnimationFrame(() => {
              this.priceUpdateFrame = null;
              this.updatePriceWithOptions();
              this.updatePurchaseButton();
            });
          });
          this.purchaseObserver.observe(this.productFormActions, {
            childList: true,
            subtree: true,
            characterData: true,
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled'],
          });
        }

        this.updatePriceWithOptions();
        this.updatePurchaseButton();
      }

      syncQuantityToMainForm(createIfMissing = true) {
        if (!this.productFormActions || !this.quantityInput) return;
        const value = Number(this.quantityInput.value);
        if (!Number.isInteger(value) || value < Number(this.quantityInput.min || 1)) return;

        let mainQuantity = Array.from(document.querySelectorAll('input[name="quantity"]'))
          .find((input) => input.form === this.productFormActions);
        if (!mainQuantity && createIfMissing) {
          mainQuantity = document.createElement('input');
          mainQuantity.type = 'hidden';
          mainQuantity.name = 'quantity';
          mainQuantity.dataset.stickyQuantity = 'true';
          this.productFormActions.appendChild(mainQuantity);
        }
        if (mainQuantity) {
          mainQuantity.value = String(value);
          mainQuantity.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      handleStickyAdd() {
        const mainButton = this.mainSubmitButton;
        if (!this.currentVariant?.available || !mainButton || mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true') {
          (this.mainProductInfo || this.productFormActions)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        this.syncQuantityToMainForm();
        mainButton.click();
      }

      updatePurchaseButton() {
        const button = this.querySelector('[data-sticky-add]');
        if (!button) return;
        const label = button.querySelector('span');
        const quantity = this.querySelector('[id^="QuantitySticky-"]');
        if (quantity) quantity.hidden = !this.mainSubmitButton;
        if (!this.currentVariant?.available) {
          button.disabled = true;
          label.textContent = FoxTheme.variantStrings.soldOut;
        } else {
          button.disabled = false;
          label.textContent = !this.mainSubmitButton
            ? 'View product details'
            : !this.mainSubmitButton.disabled && this.mainSubmitButton.getAttribute('aria-disabled') !== 'true'
              ? FoxTheme.variantStrings.addToCart
              : 'Choose options';
        }
      }

      parseMoneyToCents(value) {
        const number = value.replace(/[^\d.,]/g, '');
        const decimalAt = Math.max(number.lastIndexOf('.'), number.lastIndexOf(','));
        const hasCents = decimalAt >= 0 && number.length - decimalAt - 1 === 2;
        const digits = Number(number.replace(/\D/g, ''));
        return Number.isFinite(digits) ? digits * (hasCents ? 1 : 100) : 0;
      }

      updatePriceWithOptions() {
        if (!this.currentVariant) return;
        const appAmount = this.productFormActions?.querySelector('.avp-productoption-totalpriceadd');
        const extras = appAmount ? this.parseMoneyToCents(appAmount.textContent || '') : 0;
        const salePrice = this.querySelector('.sticky-atc-bar__product-info .f-price-item--sale');
        const regularPrice = this.querySelector('.sticky-atc-bar__product-info .f-price-item--regular');
        const format = FoxTheme.settings.moneyFormat;
        if (salePrice) salePrice.innerHTML = FoxTheme.Currency.formatMoney(this.currentVariant.price + extras, format);
        if (regularPrice) {
          const base = this.currentVariant.compare_at_price > this.currentVariant.price
            ? this.currentVariant.compare_at_price : this.currentVariant.price;
          regularPrice.innerHTML = FoxTheme.Currency.formatMoney(base + extras, format);
        }
        const note = this.querySelector('.sticky-atc-bar__price-note');
        if (note) note.hidden = extras <= 0;
      }

      updateQuantityInput() {
        const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
        this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));
        fetch(`${this.getAttribute('data-url')}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const quantity = document.querySelector(`#QuantitySticky-${this.sectionId}`);
            const newQuantity = parsedHTML.querySelector(`#QuantitySticky-${this.sectionId}`);
            if (newQuantity) {
              quantity.innerHTML = newQuantity.innerHTML;
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {});
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        this.observeTarget = this.productFormActions || this.mainProductInfo;
        if (!this.observeTarget) return;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        const rootMargin = `-80px 0px 0px 0px`;
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              // A tall configurator may never fit fully in the viewport. Show
              // the bar only after the purchase block has passed above it,
              // never while it is still visible or waiting further down.
              const passedPurchaseBlock = !entry.isIntersecting &&
                entry.boundingClientRect.bottom <= (entry.rootBounds?.top ?? 80);
              this.container.classList.toggle('sticky-atc-bar--show', passedPurchaseBlock);
            });
          },
          { threshold: 0, rootMargin }
        );
        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

      setObserveTarget() {
        this.observer.observe(this.observeTarget);
      }

      checkDevice(e) {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', this.clientHeight + 'px');
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('#product-form-sticky-atc-bar');
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }
      }

      updatePrice() {
        const classes = {
          onSale: 'f-price--on-sale',
          soldOut: 'f-price--sold-out',
        };
        const selectors = {
          priceWrapper: '.f-price',
          salePrice: '.f-price-item--sale',
          compareAtPrice: ['.f-price-item--regular'],
          unitPriceWrapper: '.f-price__unit-wrapper',
        };
        const moneyFormat = FoxTheme.settings.moneyFormat;
        const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } = FoxTheme.utils.queryDomNodes(
          selectors,
          this
        );
        const unitPrice = unitPriceWrapper.querySelector('.f-price__unit');

        const { compare_at_price, price, unit_price_measurement } = this.currentVariant;

        // On sale.
        if (compare_at_price && compare_at_price > price) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        // Sold out.
        if (!this.currentVariant.available) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        if (salePrice) salePrice.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat);

        if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
          compareAtPrice.forEach(
            (item) => (item.innerHTML = FoxTheme.Currency.formatMoney(compare_at_price, moneyFormat))
          );
        } else {
          compareAtPrice.forEach((item) => (item.innerHTML = FoxTheme.Currency.formatMoney(price, moneyFormat)));
        }

        try{
          compareAtPrice[0].classList.remove("wpd-processed");
          compareAtPrice[0].setAttribute("data-wpd-variant-compare-at-price",this.currentVariant.compare_at_price == null?"":this.currentVariant.compare_at_price);
          compareAtPrice[0].setAttribute("data-wpd-variant-price",this.currentVariant.price);
          compareAtPrice[0].setAttribute("data-wpd-variant-id",this.currentVariant.id);
          // compareAtPrice[0].setAttribute("data-wpd-product-handle", document.querySelector("#wpdproduct-modal").value);
            
        }catch(e){}

        if (unit_price_measurement && unitPrice) {
          unitPriceWrapper.classList.remove('hidden');
          const unitPriceContent = `<span>${FoxTheme.Currency.formatMoney(
            this.currentVariant.unit_price,
            moneyFormat
          )}</span>/<span data-unit-price-base-unit>${FoxTheme.Currency.getBaseUnit(this.currentVariant)}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else {
          unitPriceWrapper.classList.add('hidden');
        }
      }

      syncWithMainProductForm() {
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const isMainProduct = this.mainProductInfo && event.data.sectionId === this.mainProductInfo.dataset.section;
          if (!isMainProduct) return;
          const variant = event.data.variant;
          const variantInput = this.querySelector('[name="id"]');

          this.currentVariant = variant;
          if (!variant) {
            this.updateButton(true, '', true);
            this.updatePurchaseButton();
            return;
          }
          variantInput.value = variant.id;
          this.updatePrice();
          this.updatePriceWithOptions();
          this.updateButton(true, '', false);
          if (!variant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
          }

          this.updateQuantityInput();
          this.updatePurchaseButton();
        });
      }
    }
  );
}
